import React, { useEffect, useState } from 'react'
import { Button, Col, Row, Table } from 'react-bootstrap'

import { BsPlusLg } from 'react-icons/bs'
import ModalCertificate from './modal-certificate'
import TableCertificate from './table-certificate'
import {
  getCetificateHaveAPI,
  getTrainingListAPI
} from '../../../../services/certificate'
import { useSearchParams } from 'react-router-dom'
import { FaCircleCheck } from 'react-icons/fa6'
import UseCheckStatusAdmin from '../../../../hooks/use-check-status-admin'
import { useSelector } from 'react-redux'

function Certificate() {
  // let [searchParams, setSearchParams] = useSearchParams()
  // const orgId = searchParams.get('orgId')
  // const code = searchParams.get('code')

  const { profile } = useSelector((state) => state.profileReducer)

  const orgId = profile?.orgId
  const code = profile?.code

  const [isSave, setIsSave] = useState(false)
  const [dataTable, setDataTable] = useState([])
  const [dataMapping, setDataMapping] = useState([])
  const [onOpen, setOnOpen] = useState(false)
  const [have, setHave] = useState([])
  const statusAdmin = UseCheckStatusAdmin()
  useEffect(() => {
    const param = {
      orgId,
      code
    }
    if (orgId && code) {
      getCertificate(param)
      getCetificateHave(param)
    }
  }, [orgId, isSave])
  const getCertificate = async (param) => {
    const res = await getTrainingListAPI(param)
    if (!res) return
    if (res.status) {
      setDataTable(res.result)

      const newData = res.result.map((d, i) => {
        return {
          courseFee: d.course_fee,
          courseId: d.course_id,
          isFile: d.isFile,
          id: d.id
        }
      })
      setDataMapping(newData)
    }
  }

  const handleOpen = () => {
    setOnOpen(true)
  }
  const handleClose = () => {
    setOnOpen(false)
  }

  const getCetificateHave = async (param) => {
    // const param = {orgId, code}
    const res = await getCetificateHaveAPI(param)
    if (!res) return
    if (res.status) {
      setHave(res.result)
    }
  }
  return (
    <Row>
      <Col xl={12} className="d-flex justify-content-between mb-3">
        <div className="d-flex justify-content-start">
          <span className="my-auto text-primary me-2">Certificate</span>
          {have?.status_id === 0 ? (
            <div className="text-secondary mt-1">
              <span className="me-1">
                {' '}
                <FaCircleCheck />{' '}
              </span>
              <span className="small">{have?.status_name}</span>
            </div>
          ) : (
            <></>
          )}
        </div>

        {statusAdmin?.status_id === 1 && (
          <div className="d-flex justify-content-end">
            <Button
              size="sm"
              onClick={handleOpen}
              style={{
                width: '150px'
                // position: 'absolute'
              }}
            >
              <BsPlusLg /> Certificate
            </Button>
          </div>
        )}
      </Col>
      <Col className="">
        <>
          <div className="">
            <Row style={{ rowGap: '15px' }}>
              <Table>
                <thead
                  className="bg-hrms text-white "
                  style={{ position: 'sticky', top: '0px' }}
                >
                  <tr className="font-title-table pointer-event">
                    <td
                      className="text-center"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      #
                    </td>
                    <td style={{ whiteSpace: 'nowrap' }}>Course/ Exam Name</td>
                    <td style={{ whiteSpace: 'nowrap' }}>Type of Course</td>
                    <td style={{ whiteSpace: 'nowrap' }}>Start Date</td>
                    <td style={{ whiteSpace: 'nowrap' }}>End Date</td>
                    <td style={{ whiteSpace: 'nowrap' }}>Course Fee</td>
                    <td style={{ whiteSpace: 'nowrap' }}>Brand/ Partner</td>
                    <td style={{ whiteSpace: 'nowrap' }}>Status</td>
                    <td style={{ whiteSpace: 'nowrap' }}>Active</td>

                    <td style={{ whiteSpace: 'nowrap' }}>Insert Date</td>
                    {/* <td
                      className="text-center"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      View
                    </td>{' '} */}
                    <td style={{ whiteSpace: 'nowrap' }}>
                      <span className="fw-normal ">File </span>
                      <span className="fw-light small ">(PDF Max 8 MB)</span>
                    </td>
                    <td
                      className="text-center"
                      style={{ whiteSpace: 'nowrap' }}
                    >
                      Edit
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {dataTable.length > 0 ? (
                    dataTable.map((d, i) => (
                      <>
                        <TableCertificate
                          setIsSave={setIsSave}
                          isSave={isSave}
                          data={d}
                          keys={i}
                          dataMapping={dataMapping}
                          isFile={d.isFile}
                          fnData={getCertificate}
                          orgId={orgId}
                          code={code}
                        />
                      </>
                    ))
                  ) : (
                    <tr className="fw-light ">
                      <td colSpan={12} className="text-center">
                        - No data -
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Row>
          </div>
        </>
        {onOpen ? (
          <ModalCertificate
            have={have}
            onOpen={onOpen}
            handleClose={handleClose}
            fnData={getCertificate}
            isSave={isSave}
            setIsSave={setIsSave}
            orgId={orgId}
            code={code}
          />
        ) : (
          <></>
        )}
      </Col>
    </Row>
  )
}

export default Certificate
